const getActionsModalLegend = ({ type, mode }) => {
  switch (type) {
    case 'bot':
      return mode === 'update' ? 'chatbot_botAction_legend_edit' : 'chatbot_botAction_legend_add'
    case 'customer':
      return mode === 'update' ? 'chatbot_customerAction_legend_edit' : 'chatbot_customerAction_legend_add'
    case 'operator':
      return mode === 'update' ? 'chatbot_operatorAction_legend_edit' : 'chatbot_operatorAction_legend_add'
    default:
      return ''
  }
}

export default getActionsModalLegend
